import React, { useMemo } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useClinic } from '@/v2/hooks/useClinic'

const StripeElements = ({ children }) => {
  const { clinic } = useClinic()

  const stripePromise = useMemo(() => {
    if (!clinic) return null

    return loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY, {
      stripeAccount: clinic.stripeLedgerAccountId,
    })
  }, [clinic])

  if (!clinic) {
    return null
  }

  return <Elements stripe={stripePromise}>{children}</Elements>
}

export default StripeElements
